import { useSelector } from 'react-redux'

export function usePermissionChecker () {
  const granted = useSelector(state => state.permissions.granted)
  return function isGranted (permissionName) {
    if (Array.isArray(permissionName)) {
      return !!permissionName.find(isGranted)
    }
    return !permissionName || granted.indexOf(permissionName) >= 0 ||
      (permissionName.endsWith('.') && !!granted.find(x => x.startsWith(permissionName)))
  }
}



// WEBPACK FOOTER //
// ./src/hooks/usePermissionChecker.js